import * as Sentry from '@sentry/react';

export async function handleError(e: any) {
  Sentry.captureException(e);
}
